import Cookies from 'universal-cookie';

export const COOKIE_OPTIONS = {
  path: '/',
  secure: true,
  sameSite: 'strict' as const,
};

const cookies = new Cookies();

export default cookies;
